import { useContext, useEffect, useState } from "react";
import AuthContext from "../../../../contexts/auth";
import { translate } from "../../../../utils/Common";
import { usePackages } from "../../../../hooks/usePackages";
import { StatTile, StatTileEmpty } from "@/components/ui/stat-tile";

// paquetes retirados en el año actual
const PackagesReturnedLastYear = () => {
  const { getStatsLastYear } = usePackages();
  const [cantPackages, setCantPackages] = useState(null);

  const getData = async () => {
    const abortController = new AbortController();
    try {
      const dataToSend = {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
      };

      const response = await getStatsLastYear(
        abortController.signal,
        dataToSend
      );
      const result = getTotalPackagesReturned(response?.payload);
      setCantPackages(result);
    } catch (error) {
      console.error(error);
    }
  };

  const getTotalPackagesReturned = (listPlatf) => {
    if (listPlatf) {
      if (listPlatf.length > 0) {
        let cantTotal = 0;
        listPlatf.map(
          (plataforma) => (cantTotal += plataforma?.paquetes_reversa)
        );
        return cantTotal;
      } else return 0;
    } else return 0;
  };

  useEffect(() => {
    getData();
  }, []);
  if (!(cantPackages || cantPackages === 0)) return <StatTile loading />;
  if (cantPackages === 0) {
    return <StatTileEmpty label={translate("global.NoPackagesReverseCurrentYear")} />;
  }

  return (
    <StatTile value={cantPackages} label={translate("global.packagesReverseXYear")} />
  );
};

export default PackagesReturnedLastYear;
